import { defineStore } from "pinia";
import { ref, reactive, computed } from "vue";
import { getLocale } from "../translations";
import { generateQueryParams } from "../helpers/query";
import { formatDate } from "../helpers/date";

export const useResultsStore = defineStore("results", () => {
  const isLoading = ref(false);

  const results = reactive({
    articles: [],
    categories: [],
    locations: [],
    persons: [],
  });

  async function fetchResults(filterParams, mode = "replace", cursor = null) {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;

    // Track event
    trackMatomoEvents(filterParams);

    // Build query
    const query = generateQueryParams({ ...filterParams, cursor: cursor });

    // Send request
    const response = await fetch(`/api/klarnachrichten/${getLocale()}/filter${query}`);
    const json = await response.json();

    // Save response data
    if (json.success) {
      results.categories = json.data.categories ?? [];
      results.persons = json.data.persons ?? [];
      results.locations = json.data.locations ?? [];

      const newArticles = json.data.articles ?? [];
      if (mode === "replace") {
        results.articles = newArticles;
      } else if (mode === "append") {
        results.articles.push(...newArticles);
      }
    }

    isLoading.value = false;
  }

  function trackMatomoEvents(params) {
    for (const key in params) {
      if (key === "order") {
        continue;
      }

      const value = params[key];

      if (key.includes("date")) {
        window.klarnachrichten.trackMatomoEvent(`filter-${key}`, value ? formatDate(value, "DD-MM-YYYY") : "");
        continue;
      }

      if (typeof value === "object") {
        for (const deepKey in value) {
          const deepValue = value[deepKey];
          window.klarnachrichten.trackMatomoEvent(`filter-${key}`, deepValue);
        }
      }
    }
  }

  return {
    results,
    isLoading,
    fetchResults,
  };
});
